import axios from 'axios';
import { settings } from '@/api/config';

import { getInitData } from '@/utils/getInitData';

const tg = window?.Telegram?.WebApp;
interface ClaimResponse {
  success: boolean;
  message?: string;
  data?: {
    stars?: number;
    [key: string]: any;
  };
}

export const getBannerCpcTasks = async () => {
  if (!getInitData()) {
    throw new Error('initData отсутствует');
  }
  const encodedInitData = encodeURIComponent(getInitData());
  const url = `${settings.url}api/tasks/banners-cpc/get?initData=${encodedInitData}`;
  console.log('[CPC] GET:', url);
  const response = await axios.get(url);
  console.log('[CPC] GET response:', response);
  return response.data;
};

export const claimBannerCpcTask = async (taskId: number) => {
  if (!getInitData()) {
    throw new Error('initData отсутствует');
  }
  const encodedInitData = encodeURIComponent(getInitData());
  const url = `${settings.url}api/tasks/claim/${taskId}?initData=${encodedInitData}`;
  console.log('[CPC] POST:', url);
  const response = await axios.post(url);
  console.log('[CPC] POST response:', response);
  return response.data;
};

export const clickBannerCpcTask = async () => {
  if (!getInitData()) {
    throw new Error('initData отсутствует');
  }
  const encodedInitData = encodeURIComponent(getInitData());
  const url = `${settings.url}api/banners/banners-cpc/click?initData=${encodedInitData}`;
  console.log('[CPC] CLICK:', url);
  const response = await axios.post(url);
  console.log('[CPC] CLICK response:', response);
  return response.data;
};

export const clickBannerCpcWithProvider = async (provider: string) => {
  if (!getInitData()) {
    throw new Error('initData отсутствует');
  }
  const encodedInitData = encodeURIComponent(getInitData());
  const url = `${settings.url}api/banners/${provider}/click?initData=${encodedInitData}`;
  console.log('[CPC] CLICK:', url);
  const response = await axios.post(url);
  console.log('[CPC] CLICK response:', response);
  return response.data;
};
